// src/utils/jwt.ts
export function isJwtExpired(token: string): boolean {
  try {
    const payloadBase64 = token.split(".")[1];
    const decodedPayload = JSON.parse(atob(payloadBase64));
    const exp = decodedPayload.exp;
    if (typeof exp !== "number") return true;
    const expiry = new Date(exp * 1000);
    return new Date() > expiry;
  } catch (e) {
    return true;
  }
}

export function decodeJwt(token: string): any {
  try {
    const payloadBase64 = token.split(".")[1];
    const decodedPayload = JSON.parse(atob(payloadBase64));
    return decodedPayload;
  } catch (e) {
    return null;
  }
}

export function isAdminFromToken(token: string): boolean {
  try {
    const payload = decodeJwt(token);
    return payload && payload.admin === true;
  } catch (e) {
    return false;
  }
}
